import React from 'react'
import Dropzone from 'react-dropzone'

const MyDropzone = ({onDrop, accept, placeholder}) => (
    <Dropzone {...{onDrop, accept, multiple: false}}>
        {({getRootProps, getInputProps}) => (
            <section className="dropzone-wrapper" style={{height: 50}}>
                <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p className="m-0">{placeholder ? placeholder : 'Arrastre o haga clic para seleccionar el archivo'}</p>
                </div>
            </section>
        )}
    </Dropzone>
)

export default MyDropzone
